module.exports = __webpack_public_path__ + "img/illustrator-noInternet.43d992c6.svg";